export default __webpack_public_path__ + "static/ui-animation-f8aa611d410a2dfdda869ea34069e2ec.gif";